import React from 'react'
import { setPropTypes } from '../icons/BaseIcon'

function CNBCColorLogo({ width = 51, height = 41 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 51 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3266_9921)">
        <path
          d="M25.4607 3.97039C24.6721 2.00134 22.7509 -0.125221 19.1526 0.166911C14.5689 0.665201 13.1405 5.05786 13.8334 7.67838C12.0077 6.44221 8.90359 5.89866 6.19414 8.21955C2.69578 11.7263 4.56702 16.4689 6.49017 17.6064C4.37068 17.4102 1.02088 18.8424 0.279827 22.5888C-0.508502 27.2402 3.03736 29.9518 6.49017 29.9518H44.7779C48.7706 29.9518 50.9858 26.4977 50.7373 23.2402C50.3456 18.9888 46.4552 17.3576 44.3331 17.7071C46.1061 16.7179 48.474 12.0712 44.8734 8.41827C42.0152 5.69965 38.3717 6.68887 37.0906 7.87457C37.7812 5.6035 36.6487 0.908897 32.013 0.166405C31.6925 0.130529 31.384 0.111328 31.09 0.111328C27.5513 0.111833 25.96 2.69864 25.4607 3.97039Z"
          fill="white"
        />
        <path
          d="M6.83172 8.95978C4.81033 10.7897 4.07463 14.936 7.71858 17.3598L22.2559 27.3335L15.2072 11.1848C13.7302 7.3741 9.68944 6.54311 6.83172 8.95978Z"
          fill="#F37021"
        />
        <path
          d="M19.3456 1.10839C16.9826 1.15654 13.4342 3.97052 15.0133 8.26753L22.3036 25.4609L24.8654 7.37677C25.4582 2.88327 22.0576 0.808972 19.3456 1.10839Z"
          fill="#CC004C"
        />
        <path
          d="M26.0031 6.68702H27.3816C27.3816 6.68702 28.1177 6.68702 28.2179 7.0343C27.6754 7.4773 26.1989 7.53281 26.3949 9.8991L28.7123 25.4584L35.9528 8.21994C37.4338 4.3709 34.3252 1.15637 31.5676 1.05813C31.4389 1.04889 31.3096 1.04138 31.1757 1.04138C28.7007 1.04131 25.8645 2.84008 26.0031 6.68702Z"
          fill="#6460AA"
        />
        <path
          d="M35.6613 11.3313L28.813 27.2862L43.3461 17.2599C46.6962 14.8837 46.1559 11.0847 44.2806 9.20693C43.4944 8.3231 42.0509 7.64038 40.5219 7.64038C38.7154 7.64002 36.782 8.5982 35.6613 11.3313Z"
          fill="#0089D0"
        />
        <path
          d="M41.7189 19.53L28.0706 29.0632H44.8756C48.3233 29.0632 50.539 25.5084 49.554 22.2462C48.8943 20.1957 46.9426 18.5862 44.6772 18.5839C43.7237 18.5842 42.7124 18.8714 41.7189 19.53Z"
          fill="#0DB14B"
        />
        <path
          d="M6.44016 29.0632H22.9972L9.34545 19.53C6.19156 17.5037 2.64527 18.6894 1.365 22.0521C0.279772 25.9015 2.98937 29.0632 6.44016 29.0632Z"
          fill="#FCB711"
        />
        <path
          d="M0.222046 35.9627C0.222046 37.5863 1.54931 40.5416 6.61725 40.5416C11.2898 40.5416 12.7655 38.3975 12.7655 37.4145H9.14812C9.14812 37.4145 8.97632 38.7133 6.93573 38.7133C4.89384 38.7133 4.34163 37.0089 4.34163 36.0234C4.34163 35.0416 4.89384 33.4293 6.93573 33.4293C8.97632 33.4293 9.14812 34.5601 9.14812 34.5601H12.7655C12.7655 33.5758 11.6827 31.462 6.61725 31.462C1.54931 31.462 0.222046 34.6094 0.222046 35.9627Z"
          fill="#292526"
        />
        <path
          d="M38.1592 35.9627C38.1592 37.5863 39.4878 40.5416 44.5544 40.5416C49.2265 40.5416 50.7028 38.3975 50.7028 37.4145H47.0879C47.0879 37.4145 46.9153 38.7133 44.8742 38.7133C42.8321 38.7133 42.2793 37.0089 42.2793 36.0234C42.2793 35.0416 42.8321 33.4293 44.8742 33.4293C46.9153 33.4293 47.0879 34.5601 47.0879 34.5601H50.7028C50.7028 33.5758 49.6212 31.462 44.5544 31.462C39.4879 31.462 38.1592 34.6094 38.1592 35.9627Z"
          fill="#292526"
        />
        <path
          d="M22.6518 31.6136V37.1099L18.4419 31.6136H13.7062V40.3192H16.9528V34.7598L21.089 40.3192H25.8987V31.6136H22.6518Z"
          fill="#292526"
        />
        <path
          d="M33.0556 38.2394V38.2509H30.3504V36.6524H33.0556V36.6576C33.6332 36.6576 34.1 37.0126 34.1 37.4498C34.1 37.8858 33.6332 38.2394 33.0556 38.2394ZM30.3752 33.3068H32.9818V33.3105C33.4234 33.3105 33.7815 33.601 33.7815 33.9586C33.7815 34.3176 33.4234 34.6056 32.9818 34.6056V34.6095H30.3752V33.3068ZM35.7125 35.691C36.3035 35.691 37.5393 35.0049 37.5393 33.6757C37.5393 31.7829 34.0148 31.6136 33.4741 31.6136H26.9802V40.3192H33.4741C36.5974 40.3192 37.852 39.3325 37.852 37.6848C37.852 36.0371 35.7125 35.691 35.7125 35.691Z"
          fill="#292526"
        />
      </g>
      <defs>
        <clipPath id="clip0_3266_9921">
          <rect
            width="50.5875"
            height="40.43"
            fill="white"
            transform="translate(0.168701 0.111572)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
setPropTypes(CNBCColorLogo)
export default CNBCColorLogo
